import React, { useState } from 'react';
import api from '../utils/api';
import { useNavigate } from 'react-router-dom';
import './../assets/css/Login.css';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async () => {
    try {
      if(!email){
        setError('Please Enter Email Address');
        return;
      }

      if(!password){
        setError('Please Enter Password');
        return;
      }

      setLoading(true);
      const res = await api.post('/auth/login', { email, password });

      setLoading(false);
      localStorage.setItem('token', res.data.token);
      localStorage.setItem('loggedIn', false);
      navigate('/');

    } catch (err) {
      if(err?.response?.status == 401){
        setError(err?.response?.data?.message);
      }
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        
        {/* Header */}
        <h1 className="brand-title">Book<span className="brand-span">Fast</span></h1>
        <p className="subtitle">Please login to continue</p>

        {/* Error */}
        {error && <div className="error-msg">{error}</div>}

        {/* Form */}
          <div className="form-group">
            <label className="form-label">Email Address</label>
            <input
              type="email"
              className="form-input"
              placeholder="Enter Email Address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="form-group">
            <label className="form-label">Password</label>
            <input
              type="password"
              className="form-input"
              placeholder="Enter Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <button type="button" onClick={handleLogin} className="login-btn" disabled={loading}>
            {loading ? <div className="spinner"></div> : 'Login'}
          </button>

        <div className="footer-text">
          &copy; 2026 BookFast Inc.
        </div>
      </div>
    </div>
  );
};

export default Login;